module.exports = __webpack_public_path__ + "static/media/dashboard.bca9f664.mov";